import React from 'react';

import { IconButton } from '@mui/material';
import { Bot, Check, Pin, X } from 'lucide-react';
import { AlineTooltip } from 'src/components';
import { useEditorSuggestionState } from 'src/editor/editor-suggestion-state-registry';
import { makeStyles } from 'tss-react/mui';

import { useHandleRefine } from './useHandleRefine';
import { useSelectedSuggestionUnit } from './useNavigationHooks';
import { useSuggestionActions } from './useSuggestionActions';

const useStyles = makeStyles()(theme => ({
  buttonGroup: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  iconAccept: { color: theme.appColors.acceptSuggestion },
  iconKeepSuggestions: { color: theme.appColors.keepSuggestions },
  iconRefine: { color: theme.palette.text.secondary },
  iconReject: { color: theme.appColors.rejectSuggestion },
}));

export function SuggestionsAlertActionButtons(): JSX.Element {
  const { classes } = useStyles();
  const { handleRefine } = useHandleRefine();
  const { handleAllAiEdits } = useEditorSuggestionState();
  const { selectedSuggestionUnit } = useSelectedSuggestionUnit();
  const { handleAcceptSuggestions, handleKeepSuggestions, handleRejectSuggestions } =
    useSuggestionActions({ handleAllEnabled: true });
  const refineDisabled = !selectedSuggestionUnit;

  return (
    <div className={classes.buttonGroup}>
      <AlineTooltip arrow placement="top" title="Refine AI Edit">
        <span>
          <IconButton disabled={refineDisabled} size="small" onClick={handleRefine}>
            <Bot className={classes.iconRefine} size={20} strokeWidth={1.5} />
          </IconButton>
        </span>
      </AlineTooltip>
      <AlineTooltip arrow placement="top" title={handleAllAiEdits ? 'Reject All' : 'Reject'}>
        <IconButton size="small" onClick={handleRejectSuggestions}>
          <X className={classes.iconReject} size={20} />
        </IconButton>
      </AlineTooltip>
      <AlineTooltip arrow placement="top" title={handleAllAiEdits ? 'Accept All' : 'Accept'}>
        <IconButton size="small" onClick={handleAcceptSuggestions}>
          <Check className={classes.iconAccept} size={20} />
        </IconButton>
      </AlineTooltip>
      <AlineTooltip
        arrow
        placement="top"
        title={handleAllAiEdits ? 'Keep All Redlines' : 'Keep Redlines'}
      >
        <IconButton size="small" onClick={() => handleKeepSuggestions()}>
          <Pin className={classes.iconKeepSuggestions} size={20} />
        </IconButton>
      </AlineTooltip>
    </div>
  );
}
